import { render, staticRenderFns } from "./PlanExpired.pug?vue&type=template&id=406eb1ac&scoped=true&lang=pug&"
import script from "./PlanExpired.vue?vue&type=script&lang=js&"
export * from "./PlanExpired.vue?vue&type=script&lang=js&"
import style0 from "./PlanExpired.scss?vue&type=style&index=0&id=406eb1ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406eb1ac",
  null
  
)

export default component.exports